import bulksearch from '@redux/reducers/bulksearch'
import cases from '@redux/reducers/case'
import dashboard from '@redux/reducers/dashboard'
import fmiBulkForm from '@redux/reducers/fmiBulkForm'
import mySchedules from '@redux/reducers/mySchedules'
import pendingLessons from '@redux/reducers/pendingLessons'
import preloadedData from '@redux/reducers/preloadedData'
import singleLesson from '@redux/reducers/singleLesson'
import studentData from '@redux/reducers/studentData'

export const featureReducers = {
  bulksearch,
  pendingLessons,
  mySchedules,
  cases,
  dashboard,
  studentData,
  preloadedData,
  singleLesson,
  fmiBulkForm,
}
